import React from 'react';
import './StatsPanel.css';

import svgstat from '../assets/Group 1618874235.svg'

const StatsPanel = () => {
  return (
    <div className="stats-panel">
      <div className="stats-content">
        <div className="stat-item">
          <h2>10k+</h2>
          <p>Complete project</p>
        </div>
        <div className="stat-item">
          <h2>20+</h2>
          <p>Team member</p>
        </div>
        <div className="stat-item">
          <h2>5k+</h2>
          <p>Winning award</p>
        </div>
        <div className="stat-item">
          <h2>100+</h2>
          <p>Complete project</p>
        </div>
      </div>
      <img style={{bottom:'1px',position:'absolute',zIndex:'2',left:'60%',width:'40%',height:'auto'}}src={svgstat}></img>
    </div>
  );
};

export default StatsPanel;